<template>
  <b-col sm="12" :lg="lgSize" :offset-lg="lgOffset">
    <div class="animated fadeIn">
      <b-card class="backClass" header="Received">
        <div
          slot="header"
          style="display:flex; justify-content: space-between;"
        >
          <HeaderTitle
            title="Repair Analytics"
            productGroups="true"
            productGroupsEmit="showRepairDetails"
            @showRepairDetails="detailView"
          >
            <small style="font-weight:600; color:#20a8d8">
              (YTD)
            </small></HeaderTitle
          >
          <HeaderControl
            :showFullscreenIcon="true"
            :showDownloadPdfIcon="true"
            @emit-fullscreen="toggleFullScreen"
            @emit-pdf-download="downloadPDF"
            :loadingPdf="loadingPdf"
          ></HeaderControl>
        </div>
        <div style="width: 100%; display: flex; justify-content: flex-end;">
          <h5>Quantity</h5>
        </div>
        <div class="chart-wrapper">
          <LoadingCard v-if="loadingData"></LoadingCard>
          <highcharts
            ref="backRef"
            v-else
            :options="chartOptions"
            class="chart"
            :constructor-type="'chart'"
          ></highcharts>
        </div>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import { Chart } from "highcharts-vue";
import router from "../../../router";
import { Switch as cSwitch } from "@coreui/vue";
import HeaderTitle from "../../shared/HeaderTitle.vue";
import HeaderControl from "../../shared/HeaderControl.vue";
import LoadingCard from "../../shared/LoadingCard.vue";
import { RepairAnalyticsLineChart } from "../../../utils/ChartProps";
import { isUserLoggedIn } from "../../../utils/Utils";

export default {
  name: "RepairAnalyticsLine",
  components: {
    router,
    highcharts: Chart,
    cSwitch,
    HeaderTitle,
    HeaderControl,
    LoadingCard
  },
  props: ["lgSize", "lgOffset", "locParam", "idCity"],
  data: function() {
    return {
      fullscreen: false,
      loadingData: false,
      loadingPdf: false,
      showAll: false,
      modalDate: false,
      valueQuantity: false,
      dateFrom: "",
      dateTo: "",
      locationName: "",
      productGroup: "",
      locationsIds: "",
      total: "",
      chartOptions: {}
    };
  },

  watch: {
    valueQuantity() {
      this.fetchData();
      if (this.fullScreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
    }
  },

  methods: {
    detailView() {
      this.$emit("detailViewRepair");
    },
    toggleFullScreen() {
      this.$fullscreen.toggle(this.$el.querySelector(".backClass"), {
        wrap: false,
        callback: this.fullscreenChange
      });
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    fetchData() {
      this.loadingData = true;
      let finType = "Qty";
      let params = {};
      params = {
        date_from: "2021-01-01",
        date_to: this.dateTo,
        type: finType
      };
      this.$http
        .get("api/charts/repair.php", {
          params
        })
        .then(
          res => {
            let myArray = res.data;
            let xAxis = [];
            var datum = [];

            var fiber = {
              name: "Total",
              data: [],
              color: "rgb(124, 181, 236)"
            };

            for (var type in myArray) {
              datum.push([type, myArray[type]]);
            }
            datum.forEach(obj => {
              var last2 = obj[0].slice(-2);
              if (last2 == "01") {
                xAxis.push("January");
              }
              if (last2 == "02") {
                xAxis.push("February");
              }
              if (last2 == "03") {
                xAxis.push("March");
              }
              if (last2 == "04") {
                xAxis.push("April");
              }
              if (last2 == "05") {
                xAxis.push("May");
              }
              if (last2 == "06") {
                xAxis.push("June");
              }
              if (last2 == "07") {
                xAxis.push("July");
              }
              if (last2 == "08") {
                xAxis.push("August");
              }
              if (last2 == "09") {
                xAxis.push("September");
              }
              if (last2 == "10") {
                xAxis.push("October");
              }
              if (last2 == "11") {
                xAxis.push("November");
              }
              if (last2 == "12") {
                xAxis.push("December");
              }

              fiber.data.push(obj[1].Total);
            });

            this.chartOptions.xAxis.categories = xAxis;
            this.chartOptions.series[0] = fiber;

            this.chartOptions.series[0].color = "rgb(144, 237, 125)";

            this.chartOptions.tooltip.formatter = function() {
              return (
                "<b>" +
                this.x +
                "</b><br>" +
                this.series.name +
                ": " +
                this.y +
                " units"
              );
            };
            this.chartOptions.plotOptions.column.dataLabels.formatter =function() {
              return this.y;
            };
            this.chartOptions.yAxis.stackLabels.formatter = function() {
              return "Total: " + this.total;
            };
            
            this.loadingData = false;
          },
          err => {
            console.log(err);
            this.loadingData = false;
          }
        );
    },
    changeHeight() {
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    modalDateEvent() {
      if (this.fullScreen) {
        this.toggleFullScreen();
        this.modalDate = true;
      } else {
        this.modalDate = true;
      }
    },
    downloadPDF() {
      this.loadingPdf = true;
      this.$refs.backRef.chart.options.title.text =
        "Repair Analytics By Product Type | Year-to-date (YTD)";

      this.$refs.backRef.chart.options.title.style.display = "block";
      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "black";
      this.$refs.backRef.chart.options.legend.itemStyle.color = "black";

      this.$refs.backRef.chart.options.xAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });
      this.$refs.backRef.chart.options.yAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });

      this.$refs.backRef.chart.exportChart({
        type: "application/pdf",
        filename: "RepariAnalyticsByProductGroup-" + this.dateTo
      });

      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "white";
      this.$refs.backRef.chart.options.legend.itemStyle.color = "white";
      this.loadingPdf = false;
    }
  },
  mounted() {
    isUserLoggedIn(router);
    if (this.locParam == 1) {
      this.locationsIds = localStorage.getItem("locations");
    } else {
      this.locationsIds = this.idCity;
    }
    this.valueQuantity = false;

    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 30);

    this.dateFrom = fromDate.toJSON().slice(0, 10);
    this.dateTo = new Date().toJSON().slice(0, 10);
    this.chartOptions = RepairAnalyticsLineChart(this.total);
    this.fetchData();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.highcharts-exporting-group {
  display: none !important;
}
</style>
